$ = jQuery.noConflict();

$(() => {

	$('.agd-c-slideshow').slick({
		infinite: false,
		slidesToShow: 1,
		dots: true,
		nextArrow: '<i class="agd-c-slideshow__arrow agd-c-slideshow__arrowNext material-icons">keyboard_arrow_right</i>',
		prevArrow: '<i class="agd-c-slideshow__arrow agd-c-slideshow__arrowPrev material-icons">keyboard_arrow_left</i>'
	});

});
